/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect, useState, useContext } from 'react';
import LanguageSelect from 'components/inputs/dropdowns/LanguageSelect';
import { SelectOption } from 'components/inputs/BaseSelect';
import { Button } from '@bluebeam/react-skyline-button';
import { useLocale, useTranslator } from '@bluebeam/react-i18n';
import AppStoreContext from 'contexts/AppStoreContext';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from '@bluebeam/react-skyline-dialog';
import { useLanguageOptions } from 'hooks/useLanguageOptions';

type Props = {
  open: boolean;
  onDismiss: () => void;
};

const LanguageSettingsModal = (props: Props): React.ReactElement => {
  const { languageCode, setLanguageCode } = useLocale();
  const { translate } = useTranslator(['languageSettingsModal']);
  const { open } = props;
  const [isModalOpen, setIsModalOpen] = useState(open || false);
  const { actions } = useContext(AppStoreContext);
  const { languageOptions } = useLanguageOptions();

  const [selectedLanguage, setSelectedLanguage] =
    useState<SelectOption<string>>() || '';

  useEffect(() => {
    const currentLanguage = languageOptions.find(
      (language) => language.value === languageCode
    ) || { label: '', description: '', value: '' };

    setSelectedLanguage(currentLanguage);
  }, [languageCode]);

  const handleLanguageChange = async (
    selectedOption: SelectOption
  ): Promise<void> => {
    await setLanguageCode(selectedOption.value);
    setSelectedLanguage(selectedOption);
    actions.updatePendo();
  };

  useEffect(() => {
    setIsModalOpen(open);
  }, [open]);

  return (
    <>
      {isModalOpen && (
        <>
          <style>
            {`
          [data-reach-dialog-overlay],
          [data-reach-dialog-content],
          [data-reach-dialog-content] > div {
            overflow: initial !important;
            padding: 1rem;
            z-index:10;
          }
        `}
          </style>
          <Dialog
            ariaClose="Close"
            className="languageSettingsModal"
            onDismiss={props.onDismiss}
            size="medium"
            title={translate('languageSettingsModal:title')}
          >
            <Dialog.Content>
              <p>{translate('languageSettingsModal:content')}</p>
              <div className="row">
                <div className="w50">
                  <LanguageSelect
                    id="language-select-menu"
                    className="language-select-menu"
                    value={selectedLanguage}
                    options={languageOptions}
                    onChange={(selectedOption: SelectOption): Promise<void> =>
                      handleLanguageChange(selectedOption)
                    }
                    formatOptionLabel={function (data: any) {
                      return (
                        <>
                          {data.label}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: data.description,
                            }}
                          />
                        </>
                      );
                    }}
                  />
                </div>
              </div>
            </Dialog.Content>
            <Dialog.Footer>
              <Button
                size="32px"
                className="px4 btn-submit"
                onClick={props.onDismiss}
                variant="text"
              >
                {translate('languageSettingsModal:done')}
              </Button>
            </Dialog.Footer>
          </Dialog>
        </>
      )}
    </>
  );
};

export default LanguageSettingsModal;
